import React from 'react'
 import pdf from '../../assets/termos.pdf'

export default () => (
  <iframe src={pdf} title="Pdf" height="100%" width="100%" />
  
)